import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function MobileMenu({ isOpen, onClose, links }) {
  const location = useLocation();

  const menuVariants = {
    closed: {
      x: "100%",
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 40,
      },
    },
    open: {
      x: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 40,
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    closed: { x: 50, opacity: 0 },
    open: { x: 0, opacity: 1 },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
          />

          {/* Menu Panel */}
          <motion.div
            initial="closed"
            animate="open"
            exit="closed"
            variants={menuVariants}
            className="fixed top-0 right-0 bottom-0 w-80 bg-white z-50"
          >
            {/* Decorative Elements */}
            <div className="absolute inset-0 overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1/3 bg-gradient-to-b from-gold-50/50" />
              <div className="absolute bottom-0 right-0 w-full h-1/3 bg-gradient-to-t from-gold-50/50" />
            </div>

            <div className="relative h-full p-6 flex flex-col">
              {/* Logo Area */}
              <motion.div
                variants={itemVariants}
                className="flex items-center justify-between mb-8"
              >
                <h2 className="text-2xl font-serif font-bold text-primary-900">
                  Menu
                </h2>
                <button
                  onClick={onClose}
                  className="p-2 rounded-full hover:bg-gold-50 transition-colors"
                >
                  <svg
                    className="w-6 h-6 text-primary-900"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </motion.div>

              {/* Navigation Links */}
              <nav className="flex-1">
                <ul className="space-y-2">
                  {links.map((link) => (
                    <motion.li key={link.path} variants={itemVariants}>
                      <Link
                        to={link.path}
                        onClick={onClose}
                        className={`block px-4 py-3 rounded-xl text-lg font-medium transition-all duration-300 ${
                          location.pathname === link.path
                            ? "bg-gold-50 text-gold-600"
                            : "text-primary-900 hover:bg-gold-50"
                        }`}
                      >
                        {link.name}
                      </Link>
                    </motion.li>
                  ))}
                </ul>
              </nav>

              {/* Footer Actions */}
              <motion.div
                variants={itemVariants}
                className="pt-6 border-t border-gray-100"
              >
                <a
                  href="tel:+1234567890"
                  className="flex items-center px-4 py-3 text-primary-900 hover:text-gold-600 transition-colors"
                >
                  <svg
                    className="w-5 h-5 mr-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  Contact Us
                </a>
              </motion.div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
